import { createSlice } from '@reduxjs/toolkit';

import { fetchEmbeddableToken } from '../actions/embeddable';

const embeddableSlice = createSlice({
  name: 'embeddable',
  initialState: {
    token: null,
    error: null,
    loading: false
  },
  extraReducers: builder => {
    builder
      // Fetch Token
      .addCase(fetchEmbeddableToken.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchEmbeddableToken.fulfilled, (state, action) => {
        state.token = action.payload;
        state.loading = false;
      })
      .addCase(fetchEmbeddableToken.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      });
  }
});

export default embeddableSlice.reducer;
